import styles from './AttachmentInfoSection.module.scss';
import { useContext, useMemo } from 'react';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { CollapsedFilesErrors } from 'src/v2/components/CollapsedFilesErrors';
import { SuccessMessageWithTimer } from 'src/v2/components/SuccessMessageWithTimer';

export const AttachmentInfoSection = () => {
  const { threadInputBoxFiles } = useContext(ThreadInputBoxContext);

  const numberOfFiles = useMemo(() => {
    return threadInputBoxFiles ? Object.values(threadInputBoxFiles).length : 0;
  }, [threadInputBoxFiles]);

  const isErrorExists = useMemo(() => {
    if (threadInputBoxFiles) {
      return Object.values(threadInputBoxFiles).some(
        (file) => !!file?.errorMessage,
      );
    }
    return false;
  }, [threadInputBoxFiles]);

  const numberOfFilesWithLoading = useMemo(() => {
    if (threadInputBoxFiles) {
      return Object.values(threadInputBoxFiles).filter(
        (file) => file?.isLoading,
      ).length;
    }
    return Object.values(threadInputBoxFiles || {}).length;
  }, [threadInputBoxFiles]);

  if (!threadInputBoxFiles || numberOfFiles === 0) {
    return null;
  }

  if (numberOfFilesWithLoading > 0) {
    return (
      <div className={styles.root}>
        <span>{`Processing ${numberOfFilesWithLoading} of ${numberOfFiles} attachments...`}</span>
      </div>
    );
  }

  if (isErrorExists) {
    return <CollapsedFilesErrors />;
  }

  if (!isErrorExists && numberOfFiles > 0 && numberOfFilesWithLoading === 0) {
    return <SuccessMessageWithTimer className={styles.root} />;
  }

  return null;
};
